
  import {
    Badge,
    Button,
    Center,
    color,
    Flex,
    Heading,
    Image,
    Link,
    Stack,
    Text,
    List,ListItem,UnorderedList,
    useColorMode,
    useColorModeValue,
  } from '@chakra-ui/react';


export const Projects = ({img,title,about,areas,gitLink,netlifyLink,techStack})=>{
    
  const { colorMode, toggleColorMode } = useColorMode();

    return (
      <Center py={6} key={title} fontSize="14px" >
        <Stack
          borderWidth="1px"
          borderRadius="lg"
          w={{ sm: '100%', md: '750px', lg:"70%" }}
          height={{ sm: '476px', md: '20rem' ,lg:"400px" }}
          direction={{ base: 'column', md: 'row' }}
          bg={useColorModeValue('white','gray.900')}
          boxShadow={'2xl'}
          padding={4}>
          <Flex flex={1}  w="65%" borderRadius={"6px"} >
            <Image ml={{base:"30%",sm:"30%",md:"0%"}}
              objectFit="cover"
              boxSize="100%"
              blur={"2px"}  filter="auto"
              brightness="70%"
              _hover={{padding:"0.5%", brightness:"100%" }}
              src={
                img
              }
            />
          </Flex>
          <Stack
            flex={1}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            pt={2}>
            <Heading fontSize={'2xl'} fontFamily={'body'} color={"blue.500"} >
              {title}
            </Heading>
            <Text fontWeight={600} color={'gray.500'} size="sm" mb={4}>
              {}
            </Text>
            <Text
              textAlign={'center'}
              color={useColorModeValue('gray.900','whiteAlpha.500')}
              px={3}>
             {about}
            </Text>
            <Stack align={'center'} justify={'center'} direction={'row'} mt={6}>

              {techStack.map((el)=>{
                return (<Badge key={el}
                px={2}
                py={1}
                bg='whiteAlpha.500'
                fontWeight={'400'}>
                #{el}
              </Badge>)
              })}         

            </Stack>
           <Text textAlign="left"  textDecoration="underline" fontWeight={"700"} >Areas of Responsibility:</Text>
           <UnorderedList color={"grey"} >
            <ListItem>{areas[0]}</ListItem>
            <ListItem>{areas[1]}</ListItem>
           </UnorderedList>
            <Stack
              width={'100%'}
              mt={'2rem'}
              direction={'row'}
              padding={2}
              justifyContent={'space-between'}
              alignItems={'center'}>
              <Button
                flex={1}
                fontSize={'sm'}
                bg={useColorModeValue("grey","grey")}
                _hover={useColorModeValue("grey.800","grey.800")}
                rounded={'full'}
                _focus={{
                  bg: 'gray.200',
                }}>
               <Link target={"_blank"} href={gitLink}> GitHub Link </Link>
              </Button>  
             
              <Button
                flex={1}
                fontSize={'sm'}
                rounded={'full'}
                bg={'blue.400'}
                color={'white'}
                boxShadow={
                  '0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)'
                }
                _hover={{
                  bg: 'blue.500',
                }}
                _focus={{
                  bg: 'blue.500',
                }}>
                <Link target={"_blank"} href={netlifyLink}> Deployed Link
                </Link>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Center>
    );
  }
